/*-----------------------------------------------------------------*/
/*								中カタ、大カタ、その他ページで必要なjs					 */
/*-----------------------------------------------------------------*/

function Winop(name) { //v3.0
	//iPhoneまたは、Androidの場合はウィンドウ表示しない
	if ((navigator.userAgent.indexOf('iPhone') > 0) || (navigator.userAgent.indexOf('iPad') > 0) || (navigator.userAgent.indexOf('iPod') > 0) || navigator.userAgent.indexOf('Android') > 0) {
		location.href = name;
	}else{
//		window.open(name,"","location=yes,menubar=yes, toolbar=yes,scrollbars=yes,width=800,height="+(screen.height-100)+",resizable=yes");
		window.open(name);
	}
}

/*-------------------------------------------------
								スパム回避
 -------------------------------------------------*/
function SpamDisp() {
var emailarray1022= new Array(110,97,110,100,101,109,111,95,111,107,111,116,97,101,64,116,105,114,97,107,105,116,97,46,99,111,109)
var postemail1022=''
for (i=0;i<emailarray1022.length;i++)
postemail1022+=String.fromCharCode(emailarray1022[i])

document.write('<a href="mailto:'+postemail1022+'?subject=%82%A8%96%E2%82%A2%8D%87%82%ED%82%B9"')

}

function Mail_Addr_Disp() {
var emailarray1022= new Array(110,97,110,100,101,109,111,95,111,107,111,116,97,101,64,116,105,114,97,107,105,116,97,46,99,111,109)
var postemail1022=''
for (i=0;i<emailarray1022.length;i++)
postemail1022+=String.fromCharCode(emailarray1022[i])
document.write(postemail1022)

}
	
/*-------------------------------------------------
		検索窓-オートコンプリート
-------------------------------------------------*/

/*
jQuery(document.body).ready(function($){
  $('#kensaku_text').ajaxSuggest2('https://www.tirakita.com/sys/HP_Make/autocomplete_ajax2.php');
//  $('#as2_search_box').ajaxSuggest2('http://localhost/tirakita/sys/HP_Make/autocomplete_ajax2.php',{limit:15,width_add:60});
});*/

/*-------------------------------------------------
		indexの自動580px画像更新
-------------------------------------------------*/
var now_580px_pos;
var now_580px_num;
var timer_index580;

$(document).ready(function(){
	if($("span.px580").length == 0) return;

	now_580px_num = $("span.px580").length;
	now_580px_pos = 1;
	set_image_data(1);
	timer_set_index580();

	//マウスオーバーしたらタイマを止めてその場所の画像を表示
	$("span.px580").mouseover(function(){
		clearInterval(timer_index580);
		now_580px_pos = $("span.px580").index(this);
		set_image_data(0);
	})

	//マウスアウトしたらタイマを復活させる
	$("span.px580").mouseout(function(){
		timer_set_index580()
	})
});

/*-------------------------------------------------
				タイマー処理
-------------------------------------------------*/
function timer_set_index580()
{
	clearInterval(timer_index580);
	timer_index580 = setInterval(function(){
		now_580px_pos++;
		if(now_580px_pos >= now_580px_num) now_580px_pos = 0;
		set_image_data(1);
	},5000);
}


/*-------------------------------------------------
//					imgデータを更新する
-------------------------------------------------*/
function set_image_data(anim)
{
	//全てのimgのborderをFFFにする
	$("span.px580").each(function(){
		$(this).find("img").css('border', 'solid 3px #FFF');
	});

	var youso = $("span.px580").eq(now_580px_pos);

	var disp_div = $("#px580_html2");
	var hide_div = $("#px580_html1");

	var to_width = disp_div.data("width")+'px';
	var to_height = disp_div.data("height")+'px';

	disp_div.html(youso.html());	//spanの中からhtml部分をコピーしてからcssをいじる

	var disp_div_img = $("#px580_html2 img");	//コピーしてから新しい要素を取得
	disp_div_img.css({'height':to_height,'width':to_width,"marginLeft":to_width,'border':'0px'});

	disp_div.stop(false,true).show();

	if(anim){
		disp_div_img.animate({
			'marginLeft': '1px'
		},{
			'duration': 1500,
			'complete': function(){
				hide_div.html(disp_div.html());
				disp_div.hide();
				hide_div.show();
			}
		});
	} else {
		disp_div_img.css({'height':to_height,'width':to_width,"marginLeft":"0px",'border':'0px'});
		hide_div.html(disp_div.html());
		disp_div.hide();
		hide_div.show();
	}

	youso.find("img").css('border', 'solid 3px #AA0');

}


/*-------------------------------------------------
						TOPページの画像タブ
				今売れた商品、入荷した商品
-------------------------------------------------*/
var tab_timer;
var tab_ichi = 1;
var tab_num = 3;

$(function () {
	//要素設定
	var tab = '#tab li';
	var tabSelectImg = '#tab li.selected img';
	var selected = 'selected';

	//初期表示
	if($(tab).length == 0)	return false;
	$(tab).first().addClass(selected);
	$(tabSelectImg).attr('src', $(tabSelectImg).attr('src').replace('_of.', '_on.'));

	var selectTab = $(tab).first().find('a').attr('href');

	//遅延ロード(上のメニューの画像が読み込まれないため)
	setTimeout(function(){
		$("#tab1").load(selectTab);
	},2000);

	//クリックイベント
	$(tab).click(function () {
		$(tabSelectImg).attr('src', $(tabSelectImg).attr('src').replace('_on.', '_of.'));
		$(tab).removeClass(selected);
		$(this).addClass(selected);
		$(tabSelectImg).attr('src', $(tabSelectImg).attr('src').replace('_of.', '_on.').replace('_ov.', '_on.'));

		var selectTab = $(this).find('a').attr('href');
		$("#tab1").load(selectTab);
		return false;
	});
	//タブ ホバー イベント
	$(tab).hover(function () {
		clearInterval(tab_timer);
		$('img', this).attr('src', $('img', this).attr('src').replace('_of.', '_ov.'));
	}, function () {
		$('img', this).attr('src', $('img', this).attr('src').replace('_ov.', '_of.'));
	});

});

/*-------------------------------------------------
		サイドメニュー
-------------------------------------------------*/
$(document).ready(function(){
	$(".side_div_tab").hide();	//最初は全部消す
	$(".side_div_arrow_tab").hide();	//最初は全部消す

	$(".side_div").on("mouseover",function(){
		$(".side_div_tab").hide();	//全部消す
		var target_id = "#side_div_" + $(this).data("add");	//表示するDIVのID

		//画像を全部表示
		$(target_id).find('img').each(function(){
			var data = $(this).data("original");
			var src = $(this).attr("src");

			if(data && !src){
				$(this).attr("src",data);
				$(this).hide();
				$(this).fadeIn();
			}
		});


		var offset = $(this).offset();
		var width = parseInt($(this).css('width'))+10;
/*		offset.left += parseInt($(this).css('width'))-50;*/
/*		offset.left += parseInt($(this).css('width'))-50;*/

		/*main2のオフセット 表示するWindowの親がmain2なので、Main2位置に影響を受けるので…に*/
		if($('#main2').length) m2offiset = $('#main2').offset();
		if($('#main2_width_fix').length) m2offiset = $('#main2_width_fix').offset();
		if($('#main_width_90pas').length) m2offiset = $('#main_width_90pas').offset();
		

//		console.log("main2_top:"+m2offiset.top);
//		console.log("offset.top1:"+parseInt(offset.top));
		offset.top = offset.top - +m2offiset.top;
//		console.log("offset.top2:"+parseInt(offset.top));

		offset.top -= 10;
		$(target_id).css('top',offset.top+'px'); 
		$(target_id).css('left',width+'px');

		var target_id2 = "#side_div_arrow_" + $(this).data("add");	//横矢印のDIV
		$(target_id2).css('top',offset.top+'px'); 
		$(target_id2).css('left',width+'px');

		//ウィンドウの下編に合わせる
//		var div_bottom = offset.top + $(target_id).height() - h.scrollTop();

		var win_bottom = $(window).scrollTop() + $(window).height();
		var div_bottom = offset.top+$(target_id).height();

		if(win_bottom < div_bottom){
//			var new_top = win_bottom - $(target_id).height();
			var new_top = ($(window).scrollTop() + $(window).height()) - $(target_id).height();


//			var new_top = (win_bottom - $(target_id).height());
			$(target_id).css('top',new_top+'px'); 
		}

		$(target_id).show();	//出現
		$(target_id2).show();	//出現
	});

	//Windows8 IE10のタッチパネルの時、消す動作
	if(navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 1) {
		// タッチパネル
		$("body").bind("click",function(){
			$(".side_div_tab").hide();	//最初は全部消す
			$(".side_div_arrow_tab").hide();	//最初は全部消す
		});
	}

	//外れたら消す
	$(".side_div").on("mouseout",function(){
		if(navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 1) {
			//Windows8 IE10のタッチパネルの時は消さない
			exit();
		}
		var target_id = "#side_div_" + $(this).attr("id");	//表示するDIVのID
		$(target_id).hide();
		$(".side_div_tab").hide();	//全部消す
		$(".side_div_arrow_tab").hide();	//全部消す
		return false;
	});

	//DIVの中にいるときは表示
	$(".side_div_tab").on("mouseover",function(){
		$(this).show();	//出現
		var target_id = $(this).attr("id");	//表示するDIVのID
		target_id = target_id.replace("side_div_", "#side_div_arrow_"); 
		$(target_id).show();	//出現
	});
	//DIVの中から出た時に消す
	$(".side_div_tab").on("mouseout",function(){
		$(this).hide();	//消す
		$(".side_div_tab").hide();	//全部消す
		$(".side_div_arrow_tab").hide();	//最初は全部消す

	});
});

//---------------------------------------------------
//mp3再生 共用グローバル変数
//---------------------------------------------------
var mp3_start_img = 'https://www.tirakita.com/Gif/mp3_play.gif';
var mp3_stop_img = 'https://www.tirakita.com/Gif/mp3_play_stop.gif';
var mp3_prev_goods_id;
var audioObj;

/*----------------------------------------------*/
/*--------					MP3の再生					 ---------*/
/*----------------------------------------------*/
$(function(){
	var audioObj;
	var mp3_prev_goods_id;
	var mp3_start_img = 'https://www.tirakita.com/Gif/mp3_play.gif';
	var mp3_stop_img = 'https://www.tirakita.com/Gif/mp3_play_stop.gif';

	$(".mp3_play").click(function(){
		file_name = $(this).data("file_name");
		goods_id = $(this).data("goods_id");

		//停止とイメージの書き戻し
		if(audioObj) audioObj.pause(); // これがないと以前の音楽は停止しない

		if(mp3_prev_goods_id){
			$('#mp3_'+mp3_prev_goods_id).attr('src',mp3_start_img);
		}
		if(mp3_prev_goods_id == goods_id){
			mp3_prev_goods_id = 0;
			return;	//もし同じ番号だったら再生停止
		}

		//再生開始とイメージの変更
	  audioObj = new Audio(file_name);
	  audioObj.play();
		var tmp = '#mp3_'+goods_id;
		$(tmp).attr('src',mp3_stop_img);
		mp3_prev_goods_id = goods_id;

	});
});

/*----------------------------------------------*/
/*--------					MP3の再生					 ---------*/
/*----------------------------------------------*/
function start_music(file_name,goods_id){
	//停止とイメージの書き戻し
	if(audioObj) audioObj.pause(); // これがないと以前の音楽は停止しない

	if(mp3_prev_goods_id){
		$('#mp3_'+mp3_prev_goods_id).attr('src',mp3_start_img);
	}
	if(mp3_prev_goods_id == goods_id){
		mp3_prev_goods_id = 0;
		return;	//もし同じ番号だったら再生停止
	}

	//再生開始とイメージの変更
  audioObj = new Audio(file_name);
  audioObj.play();
	var tmp = '#mp3_'+goods_id;
	$(tmp).attr('src',mp3_stop_img);
	mp3_prev_goods_id = goods_id;
}

//---------------------------------------------------
//	indexのFB likeボタン遅延ロード
//---------------------------------------------------
$(document).ready(function(){setTimeout(function(){$('#fb_like_box').html('<iframe src="http://www.facebook.com/plugins/like.php?href=http%3A%2F%2Fwww.facebook.com%2Fpages%2FTirakita%2F236752786407840&send=false&layout=button_count&width=170&show_faces=false&action=like&colorscheme=light&font=lucida+grande&height=21" scrolling="no" frameborder="0" style="border:none; margin:5px 0px 5px 0px; overflow:hidden; width:170px; height:21px;" allowTransparency="true"></iframe>')}, 3000);});

//---------------------------------------------------
//	中カタログ詳細のデータを入れるヘルパー
//---------------------------------------------------
$(function(){
	$("#auto_msdata_get").click(function(){
		$("#auto_msdata_get2").load("https://www.tirakita.com/sys/HP_Make/data_transport2syousai_ajax.php?msid="+$("#auto_msdata_get").data("id"));
	});
});

//---------------------------------------------------
//	フェードイン・フェードアウトするカートボタン
//---------------------------------------------------
$(function(){
	$(".cart_fade_parent").hover(function(){
		$('.cart_fade').hide();
		$(this).find('.cart_fade').fadeIn(500);
	},
	function(){
//		$(this).find('.cart_fade').hide();
	});
});

//-------------------------------------
//	その商品をほしい物リストに入れる-中カタ、検索ページ
//-------------------------------------
$(function(){
	$('.cart_heart').click(function(){
		var csrf = $('#csrf').val();
		var gid = $(this).data('gid');
		$(this).load('https://www.tirakita.com/sys/HP_Make/add_goods_hoshiimono_list_ajax.php?mode=mcata&goods_id='+gid+'&csrf='+csrf);
	});

});


	//--------------------------------------
	//	SuperDeliveryジャンルの入力ウィンドウを開く
	//--------------------------------------
$(function(){
	$('.super_delivery_genre').click(function(){
		var target_selecter = $(this).attr('id');
		var zokusei_selecter = "";
		var goods_id = "";
		var url = 'https://www.tirakita.com/syssyssyssyssyssyssyssyssyssys/super_delivery/hepler_input/superdelivery_dir_id_category_input_win.php?target_selecter='+target_selecter+'&zokusei_selecter='+zokusei_selecter+'&goods_id='+goods_id+'&val='+$("#"+target_selecter).val();
		window.open( url, '','width=500, height=500, menubar=no, toolbar=no, scrollbars=yes' )
	});
});


//------------------------------------------------------
//		中カタログ詳細のもっと見るAjax
//------------------------------------------------------
//$(function(){
//	$(".disp_more_line").click(function(){
//		var url = "https://www.tirakita.com/sys/HP_Make/m_c_ajax.php?"+$(this).data("ajax");
//
//		var token = $("#token").val()
//		if(token) url = url +"&token="+token;
//
//		$(this).parent().fadeOut(0).fadeIn(2000).load(url);
//		return false;
//	});
//});

$(function(){

	$(".disp_more_line").each(function(){
		var smid = $(this).data("ajax");
		var now_height = $("#div_"+smid).height();
		var new_height = $(this).data("tate_lines") * 200;
		if(new_height < now_height){
			$("#div_"+smid).height(new_height);
		}else{
			$(this).parent().hide();
		}
	});

	$(".disp_more_line").click(function(e){
		e.preventDefault();
		var smid = $(this).data("ajax");
		$("#div_"+smid).css("height","100%");
		$(this).parent().hide();
	});

});


//------------------------------------------------------
//		中カタログ詳細を全部表示するAjax
//------------------------------------------------------
//function load_ms(line_id,id){
//	id = "#"+id;
//
//	$(line_id).animate({
//		opacity:"0%"},300);
//	$(line_id).hide();
//
//	var old_h = $(id).height(); //一度100%にして高さをpxで貰わないとスムースにアニメートしない
//	$(id).height("100%");
//	var new_h = $(id).height();
//	$(id).height(old_h);
//
//	$(id).animate({
//		height:new_h
//	},1000);
//}


